import React from "react";
import "./inner-wrapper.css";

function Innerwrapper({ children }) {
  return (
    <>
      <div className="inner-wrapper">
        <div className="container">{children}</div>
      </div>
    </>
  );
}

export default Innerwrapper;
